module.exports = __webpack_public_path__ + "img/grid-2-plus.d22a5e78.svg";